<template>
<div>
    <div class="content">
        <div class="cont-list">
            <span class="list">{{
          this.parentRoute.menuName + "-" + this.route.menuName
        }}</span>
            <span class="masge">当前共有{{ total }}条{{ this.route.menuName }}</span>
        </div>
        <div class="header">
            <div class="left">
               
                <SelectFilter ref="selectFilter" :options="filterOptions" :query="query" @filterChange="filterChange" @reset="reset"></SelectFilter>
            </div>
            <div class="right">
                <!-- <el-button class="btn primary" type="primary" style="margin-right: 10px"
                @click="showTransfer">自定义设置</el-button> -->
                <div class="search">
                    <el-input type="text" v-model="query.keyWord" @keyup.enter.native="queryChange">
                        <i slot="suffix" class="el-icon-search" @click="queryChange"></i>
                    </el-input>
                    <!-- <i class="el-icon-search padding10" v-preventReClick @click="queryChange"></i> -->
                </div>
                <span v-preventReClick @click="reset">重置</span>
            </div>
        </div>

        
            <el-table ref="multipleTable" border row-key="id" v-loading="loading" :data="tableData" :max-height="tableHeight" style="width: 100%" @selection-change="handleSelectionChange" stripe :header-cell-style="{ background: '#DDEBFF' }">
                <template slot="empty">
                    <div class="empty-div" :style="{ height: tableHeight + 'px' }">
                        <img src="../../../../assets/noData.png" width="240" height="240" />
                        <span class="empty-span">抱歉！当前搜索状态下暂无相关数据，请核对后再查询！</span>
                        <div class="empty-rest" @click="reset">恢复默认</div>
                    </div>
                </template>
                <el-table-column align="center" :reserve-selection="true" type="selection" fixed width="55">
                </el-table-column>
                <el-table-column prop="tableNo" width="170" label="任务单号">
                    
                </el-table-column>
                <el-table-column prop="businessTypeName" width="120" label="业务类型"></el-table-column>
                       <el-table-column prop="createdTime" label="操作时间" width="120">
                    <template slot-scope="scope">{{
                parseTime(new Date(scope.row.createdTime), "{y}-{m}-{d}")
              }}</template>
                </el-table-column>
                <el-table-column :show-overflow-tooltip="true" prop="operationUserName" width="100" label="操作人"></el-table-column>
         
                <el-table-column prop="warehouseName" :show-overflow-tooltip="true" label="库房" width="120"></el-table-column>
                <el-table-column prop="supplierProductNo" min-width="170" label="供应商产品编码"></el-table-column>
                <el-table-column prop="productName" min-width="120" label="产品名称"></el-table-column>
                <el-table-column prop="specName" min-width="100" label="规格型号"></el-table-column>
                <el-table-column prop="manufacturerName" min-width="100" label="生产厂家"></el-table-column>
                <el-table-column prop="number" label="数量" />
                <el-table-column prop="unitName" label="单位" />
                <el-table-column prop="batch" label="批次号" />
                <el-table-column prop="serialNo" label="序列号" />
                <el-table-column prop="oldLocationName" label="原货位" />
                <el-table-column prop="newLocationName" label="新货位" />
                 <el-table-column fixed="right" prop="operation" label="标签详情" width="100">
                    <template slot-scope="scope">
                      <el-button type="text"  v-preventReClick class="color-blue" @click="viewDetails(scope.row)">查看</el-button>
                    </template>
                  </el-table-column>
            </el-table>

        </div>
    
    <div class="pagination">
        <!-- <span style="float: left">勾选金额合计：{{ totalAmount }}元</span> -->
        <el-pagination background layout="sizes, prev, pager, next, jumper" :page-sizes="[10, 20, 50, 100, 200, 500, 1000]" :page-size="query.pageSize" @size-change="handleSizeChange" :current-page="query.pageIndex" :total="total" @current-change="changePage">
        </el-pagination>
    </div>
    
    <LabelDetailsDialog v-if="labelDetailsVisible" :open="labelDetailsVisible" :data="labelDetailsData" 
    @tagCodeDelete="tagCodeDelete"
    @close="closeLabelDetailsDialog"/>
    <PackageLabelDialog v-if="packageLabelVisible" :open="packageLabelVisible" :data="packageLabeData"
    @viewDetails="viewDetails"
     @tagCodeDelete="tagCodeDelete"
     @close="closePackageLabelDialog"/>

</div>
</template>

<script>
import {
    GetPDAOperationLogs,
    GetTagCodeDetailsByTagCodeIds,
} from "@/api";
import GetDataMixin from "@/mixin/getData-mixin.js";
import GetDataSpdMixin from "@/mixin/getData-spd-mixin.js";
import {
    PdaOperationTypeOptions
} from "@/enum";
import SelectFilter from "@/components/table-select-filter";
import BaseListMixin from "@/mixin/baseList-mixin.js";
import tagCodeMixin from "@/mixin/tagCode-mixin";
import LabelDetailsDialog from "@/components/labelDetails-dialog";
import PackageLabelDialog from "@/components/packageLabel-dialog";
export default {
    mixins: [GetDataMixin, GetDataSpdMixin, BaseListMixin,tagCodeMixin],
    components: {
        SelectFilter,
        LabelDetailsDialog,
        PackageLabelDialog
    },
    data() {
        return {
            GetDatasAction: GetPDAOperationLogs,
            PdaOperationTypeOptions,
            editPath: "accept-out-stock-edit",

            filterOptions: [{
                    name: "任务单号",
                    type: "input",
                    code: "keyWord",
                },
                {
                    name: "业务类型",
                    type: "select",
                    code: "pdaOperationType",
                    data: PdaOperationTypeOptions,
                },
                {
                    name: "操作时间",
                    type: "date",
                    code: "date",
                },
                {
                    name: "操作人",
                    type: "input",
                    code: "createdUserName",
                },
                {
                    name: "库房",
                    type: "select",
                    code: "warehouseId",
                    filterMethod: this.getWarehouses,
                    data: [],
                },
          
                {
                    name: "供应商产品编码",
                    type: "input",
                    code: "supplierProductNo",
                },
                {
                    name: "产品名称",
                    type: "input",
                    code: "productName",
                },
                {
                    name: "规格型号",
                    type: "input",
                    code: "specName",
                },
                {
                    name: "标签码",
                    type: "input",
                    code: "tagCode",
                },
                    {
                    name: "批次号",
                    type: "input",
                    code: "batch",
                },
            ],
        };
    },
    methods: {
      viewDetails(row){
        GetTagCodeDetailsByTagCodeIds({tagCodeIds:row.tagCodeIds}).then(res => {
            this.labelDetailsVisible = true;
            this.labelDetailsData = {
              data:res.returnData.data
            }
       
        })
      }
    },
    mounted() {},
};
</script>

<style lang="scss" scoped>
</style>
